var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      !_vm.bioinsumo.utilizaBioinsumos
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: { label: "Utiliza bioinsumo?", content: "Não" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: { label: "Utiliza bioinsumo?", content: "Sim" }
                  }),
                  _vm._v(" "),
                  _c("app-display", {
                    attrs: {
                      label: "Tipo(s) de bioinsumos aplicados:",
                      content: _vm.formataBioinsumos(_vm.bioinsumo.bioinsumos)
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.verificaBiofertilizantes(_vm.bioinsumo.bioinsumos)
                    ? _c("app-display", {
                        attrs: {
                          label: "Biofertilizantes:",
                          content: _vm.getBiofertilizantes(
                            _vm.bioinsumo.bioinsumos
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.verificaOutros(_vm.bioinsumo.bioinsumos)
                    ? _c("app-display", {
                        attrs: {
                          label: "Outros tipos de bioinsumos:",
                          content: _vm.getOutros(_vm.bioinsumo.bioinsumos)
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2" }, [
      _c("span", { staticClass: "title-praticas" }, [
        _vm._v("Dados dos bioinsumos")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6fda4ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6fda4ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/components/Bioinsumos.vue
// module id = null
// module chunks = 